import { TeamSettingsLayout } from '../../components/TeamSettingsLayout';
import { TeamIntegrationCards } from '../../components/TeamIntegrationCards/TeamIntegrationCards';

export const TeamIntegration = () => (
  <TeamSettingsLayout>
    <TeamIntegrationCards />
  </TeamSettingsLayout>
);
